module.exports = __webpack_public_path__ + "img/ellipse.0025ffb5.svg";